module.exports = __webpack_public_path__ + "img/g.d3152517.jpg";